// extracted by mini-css-extract-plugin
export var boldText = "_3b-4";
export var checkboxContainer = "_3b-6";
export var closeIcon = "_3b-g";
export var container = "_3b-0";
export var drawer = "_3b-8";
export var drawerContent = "_3b-9";
export var extraSmallText = "_3b-5";
export var fulfillmentGroupTable = "_3b-e";
export var largeText = "_3b-3";
export var loadingSpinnerContainer = "_3b-h";
export var mediumText = "_3b-2";
export var narrow = "_3b-f";
export var notificationLink = "_3b-j";
export var packageCheckIconContainer = "_3b-7";
export var slideoutHeaderContainer = "_3b-a";
export var slideoutModal = "_3b-c";
export var stickyHeaderWrapper = "_3b-b";
export var table = "_3b-i";
export var tableContainer = "_3b-d";
export var tertiaryText = "_3b-1";